import { create } from 'zustand'

interface LocationInfo {
  ip: string
  city: string
  region: string
  country: string
  loc: string
  timezone: string
}

interface LocationState {
  location: LocationInfo | null
  loading: boolean
  error: string | null
  fetchLocation: () => Promise<void>
}

declare global {
  interface Window {
    userlocation: LocationState
  }
}

export const useLocationStore = create<LocationState>((set) => ({
  location: null,
  loading: false,
  error: null,
  fetchLocation: async () => {
    try {
      set({ loading: true, error: null })
      const response = await fetch('/user/location')
      if (!response.ok) throw new Error('Failed to fetch location')
      const data = await response.json()
      set({ location: data })
      window.userlocation = data // Set global variable for non-React usage
    } catch (err) {
      set({ error: err instanceof Error ? err.message : 'Failed to fetch location' })
    } finally {
      set({ loading: false })
    }
  }
}))